module.exports = __webpack_public_path__ + "img/resources_active.af3860ad.svg";